import { takeEvery, takeLatest, fork, call, put, all, select } from 'redux-saga/effects';
import FetchService from 'service/FetchService';
import {actionMeta} from './meta';
import {responseObject} from 'storeState/helpers';
import {authToken} from './selectors';
import {authenticatedRequest} from 'storeState/auth/saga';
import {errorSafeSaga} from 'service/StoreService';

const ty = actionMeta.identifiers;
const api = actionMeta.urlBuilders;
const actions = actionMeta.actionCreators;

function* projectsList(action) {
    const url = api.buildProjectsListUrl(action.payload.params);
    const authGet = yield authenticatedRequest(FetchService.get);
    const {loadInBackground, ...otherParams} = action.payload.params;
    const {response, data} = yield call(authGet, {
        url: url,
        params: otherParams
    });
    const error = response.status !== 200;
    yield put(actions.projectsListResponse({ payload: {data: data, params: action.payload.params}, error: error }));
}

function* watchProjectsList() {
    yield takeLatest(ty.PROJECTS_LIST_REQUEST, errorSafeSaga(projectsList));
}

function* projectDelete(action) {
    const url = api.buildProjectDeleteUrl({ project_id: action.payload.params.project_id });
    const authDel = yield authenticatedRequest(FetchService.delete);
    const {response, data} = yield call(authDel, {
        url: url,
        params: action.payload.params
    });
    const error = response.status !== 200;
    yield put(actions.projectDeleteResponse({ payload: {data: data}, error: error }));
    yield put(actions.projectsListRequest(action.payload.params));
}

function* watchProjectDelete() {
    yield takeLatest(ty.PROJECT_DELETE_REQUEST, errorSafeSaga(projectDelete));
}

function* projectCreate(action) {
    const url = api.buildProjectCreateUrl();
    const authPost = yield authenticatedRequest(FetchService.post);
    console.log("action.payload.params", action.payload.params);
    console.log("action.payload.params.project", action.payload.params.project);
    const {response, data} = yield call(authPost, {
        url: url,
        params: action.payload.params.project
    });
    const error = response.status !== 200;
    yield put(actions.projectCreateResponse({ payload: {data: data}, error: error }));
    yield put(actions.projectsListRequest(action.payload.params));
}

function* watchProjectCreate() {
    yield takeLatest(ty.PROJECT_CREATE_REQUEST, errorSafeSaga(projectCreate));
}

function* projectUpdate(action) {
    const url = api.buildProjectUpdateUrl({ project_id: action.payload.params.project_id });
    const authPut = yield authenticatedRequest(FetchService.put);
    const {response, data} = yield call(authPut, {
        url: url,
        params: action.payload.params.project
    });
    const error = response.status !== 200;
    yield put(actions.projectUpdateResponse({ payload: {data: data}, error: error }));
    yield put(actions.projectsListRequest(action.payload.params));
}

function* watchProjectUpdate() {
    yield takeLatest(ty.PROJECT_UPDATE_REQUEST, errorSafeSaga(projectUpdate));
}


function* saga() {
  yield all([
    fork(watchProjectsList),
    fork(watchProjectDelete),
    fork(watchProjectCreate),
    fork(watchProjectUpdate),
  ])
}

export default saga;



// WEBPACK FOOTER //
// ./src/storeState/projects/saga.js